import React from 'react';
import Svg from './Svg';

export default function LinkedIn(props) {
  return (
    <Svg
      {...props}
      d="M816.8 104.053H183.2c-43.56 0-79.2 35.64-79.2 79.2v633.6c0 43.56 35.64 79.2 79.2 79.2h633.6c43.56 0 79.2-35.64 79.2-79.2v-633.6c0-43.56-35.64-79.2-79.2-79.2zm-475.2 673.2H222.8v-356.4h118.8v356.4zm-59.4-423.72c-39.6 0-71.28-31.68-71.28-71.28s31.68-71.28 71.28-71.28 71.28 31.68 71.28 71.28-31.68 71.28-71.28 71.28zm495 423.72H658.4v-209.88c0-31.679-27.72-59.4-59.4-59.4s-59.4 27.721-59.4 59.4v209.88H420.8v-356.4h118.8v47.52c19.8-31.68 63.36-55.44 99-55.44 75.24 0 138.6 63.36 138.6 138.6v225.72z"
    />
  );
}
